<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="100" label-position="left" inline>
          <FormItem label="项目名称:">
            <Input v-model="query.ProjectName" style="width:160px" placeholder="请输入项目名称"></Input>
          </FormItem>
          <FormItem label="订单号:">
            <Input v-model="query.OrderNumber" style="width:160px" placeholder="请输入订单号"></Input>
          </FormItem>
          <FormItem label="采购负责人:">
            <Input v-model="query.CGBUserName" style="width:160px" placeholder="请输入采购负责人"></Input>
          </FormItem>
          <FormItem label="承接厂商:">
            <Input v-model="query.SupplierName" style="width:160px" placeholder="请输入承接厂商"></Input>
          </FormItem>
          <FormItem label="受单日期:">
            <DatePicker v-model="rangeTimeSDRQ" type="daterange" format="yyyy-MM-dd" style="width:160px" placement="bottom-end" placeholder="请选择受单日期"></DatePicker>
          </FormItem>
          <FormItem label="接单状态:">
            <Select placeholder="请选择接单状态" style="width:160px" v-model="query.orderTakingStatus">
              <Option value=" ">------</Option>
              <Option v-for="item in orderTakingStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="反馈状态:">
            <Select placeholder="请选择反馈状态" style="width:160px" v-model="query.feedbackStatus">
              <Option value=" ">------</Option>
              <Option v-for="item in feekbackStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="交付状态:">
            <Select placeholder="请选择交付状态" style="width:160px" v-model="query.deliveryStatus">
              <Option value=" ">------</Option>
              <Option v-for="item in deliveryStatusData" :key="item.value" :value="item.value">{{ item.text }}</Option>
            </Select>
          </FormItem>
          <FormItem label="是否到厂:">
            <Select placeholder="请选择是否到厂" style="width:160px" v-model="query.arrivalStatus">
              <Option value=" ">------</Option>
              <Option v-for="item in arrivalStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
            <!-- <Checkbox v-model="query.ContainKBDCRQ">排除未到厂</Checkbox> -->
          </FormItem>
          <FormItem label="反馈规则:">
            <Select placeholder="请选择" style="width: 160px" v-model="query.feedbackType">
              <Option value=" ">------</Option>
              <Option v-for="item in feedbackTypeData" :key="item.value" :value="item.value">{{ item.text }}</Option>
            </Select>
            <!-- <Checkbox v-model="query.ContainKBDCRQ">排除未到厂</Checkbox> -->
          </FormItem>
          <FormItem label="产线:">
            <Select placeholder="请选择产线" style="width:160px" v-model="query.ProductionLineName">
              <Option value=" ">------</Option>
              <Option v-for="item in productionLineList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="要求到厂日期:">
            <DatePicker v-model="rangeTimeYQDCRQ" type="daterange" format="yyyy-MM-dd" style="width:160px" placeholder="请选择要求到厂日期"></DatePicker>
          </FormItem>
          <FormItem label="实际到厂日期:">
            <DatePicker v-model="rangeTimeSJDCRQ" type="daterange" format="yyyy-MM-dd" style="width:160px" placeholder="请选择实际到厂日期"></DatePicker>
          </FormItem>
          <FormItem label="派单确认时间:">
            <DatePicker v-model="rangeTimePDQR" type="daterange" format="yyyy-MM-dd" style="width:160px" placeholder="请选择实际到厂日期"></DatePicker>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-archive" type="primary" size="default" @click="exportControlList" class="toolbar-btn">导出</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="md-archive" type="primary" size="default" @click="exportControlStatusList" class="toolbar-btn">导出状态统计</Button>
          </FormItem>

          <!--  v-if="this.isShowCancelBtn"  -->
          <FormItem :label-width="0">
            <Button icon="md-checkmark" type="primary" size="default" v-if="this.isShowCancelBtn" @click="bulkOrder" class="toolbar-btn">批量接单{{seleceIdSet.length>0?'（已选'+seleceIdSet.length+'条）':''}}</Button>
          </FormItem>

        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" @on-selection-change="tabSelectionChange" border :data="list">
            <template slot="implementResult" slot-scope="{ row }">
              <div>
                <Input type="text" v-if="row.deliveryStatus==='临期'" v-model="row.implementResult" placeholder="请输入落实结果" @on-blur="handleImplementResultBlur(row)">
                </Input>
                <span v-else>{{ row.implementResult }}</span>
              </div>
            </template>
          </Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <Modal v-model="isShowCancel" :mask-closable="false" class="modal-cont">
      <p class="content">确认取消管制表吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowCancel = false">取消</Button>
        <Button type="primary" @click="confirmCancel">确认</Button>
      </div>
    </Modal>
    <Modal v-model="isShowModal" :mask-closable="false" class="modal-cont modal-cont-jilu" :loading="modalLoading" title="供应商反馈记录">
      <Timeline class="cont">
        <TimelineItem v-for="(item,index) in feedbacklist" :key="item.index">
          <Row>
            <Col span="4">进度阶段：</Col>
            <Col span="8">{{ item.pushPhaseText }}</Col>
            <Col span="4">供应商：</Col>
            <Col span="8">{{ supplierName }}</Col>
          </Row>
          <Row>
            <Col span="4">提醒时间：</Col>
            <Col span="8">{{ item.pushTimeText }}</Col>
            <Col span="4">反馈情况：</Col>
            <Col span="8">{{ item.feedBackText }}</Col>
          </Row>
          <template v-if="item.feedBackText=='已反馈'">
            <Row>
              <Col span="4">反馈时间：</Col>
              <Col span="8">{{ item.feedbackTimeText }}</Col>
            </Row>
            <Row>
              <Col span="4">反馈内容：</Col>
              <Col span="20">{{ item.feedbackContent }}</Col>
            </Row>
            <Row align="top">
              <Col span="4">相关图片：</Col>
              <Col span="20">
              <div v-if="item.imageFiles.length > 0">
                <div v-for="(img,ing_i) in item.imageFiles" :key="ing_i" class="imgbox">
                  <img class="img" :src="$constDefinition.baseUrl + img.url" @click="previewImg(img.url)" />
                </div>
              </div>
              <div v-else>无</div>
              </Col>
            </Row>
          </template>
          <div v-if="item.feedBackText!='已反馈'">
            <div class="feedback">
              <Button type="warning" v-if="isFeekbackShows['isFeekbackShow'+index]==false" @click="feekbackHandel(item.imageFiles,index,item.id)">提交反馈
                <Icon style="position:relative;top:-1px;left:2px;" type="md-arrow-forward" />
              </Button>
              <div class="feekbackbg" v-else>
                <Form :ref="'feekbackForm'+index" :model="feekbackForm" :label-width="90" :rules="rules" label-position="left" inline>
                  <FormItem label="反馈进度:" prop="feedbackContent" style="width: 90%">
                    <Input type="textarea" v-model="feekbackForm.feedbackContent" placeholder="请输入反馈进度"></Input>
                  </FormItem>

                  <FormItem label="相关图片:" prop="uploadList" class="img" style="width: 100%;">

                    <div class="demo-upload-list" v-for="(item11,i) in uploadList" :key='i'>
                      <template>
                        <!-- <Image :src="$constDefinition.baseUrl +item11.imageUrl" fit="cover" width="100%" height="100%" /> -->
                        <div class="ivu-image" style="width: 100px; height: 100px;">
                          <div class="ivu-image-inner"><img class="ivu-image-img" alt="fill" :src="$constDefinition.baseUrl +item11.imageUrl" loading="eager" referrerpolicy style="object-fit: fill;">
                          </div>
                        </div>
                        <div class="demo-upload-list-cover">
                          <Icon type="ios-eye-outline" @click="previewImg(item11.imageUrl)"></Icon>
                          <Icon type="ios-trash-outline" @click="handleRemove(item11.guid)"></Icon>
                        </div>
                      </template>
                    </div>
                    <Upload ref="upload" :show-upload-list="true" :on-success="handleSuccess" :data='{id:currentId,guid:newGuid}' :format="['jpg','jpeg','png']" :max-size="1024*4" :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" type="drag" :action="$constDefinition.baseUrl + '/cgbfile/UploadBySupplierFeedback'" style="display: inline-block;width:58px;">
                      <div style="width: 58px;height:58px;line-height: 58px;">
                        <Icon type="ios-camera" size="20"></Icon>
                      </div>
                    </Upload>
                    <!-- <i-image-preview v-model="visible" :preview-list="['https://file.iviewui.com/images/' + imgName]" /> -->
                  </FormItem>
                  <FormItem label="" style="width: 90%">
                    <Button type="primary" @click="feekbackSub(index,item.guid)">提交
                    </Button>
                    <Button @click="closefeedback(index)">取消
                    </Button>
                  </FormItem>

                </Form>
              </div>
            </div>
          </div>

        </TimelineItem>
      </Timeline>
      <Input
        v-show="feedbacklist.length === 0"
        v-model="noFeedbackTips"
        type="textarea"
        disabled
        :rows="4"
        style="width: 100%"
      ></Input>
      <div slot="footer" class="footer">
        <Button type="primary" @click="closeModel">关闭</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import moment from 'moment'
import Util from '../../lib/util'
export default {
  name: 'controllist',
  data() {
    return {
      query: {
        IncludeBOMImportRecord: true,
        IncludeSupplier: true,
        controlDisable: true,
        IncludeCGBUser: true,
        loadFeedbackStatus: true,
        feedbackStatus: '',
        orderTakingStatus: '',
        arrivalStatus: '',
        ProjectName: '',
        CGBUserName: '',
        SupplierName: '',
        ProductionLineName: '',
        StartSDRQ: '',
        EndSDRQ: '',
        StartYQDCRQ: '',
        EndYQDCRQ: '',
        StartSJDCRQ: '',
        EndSJDCRQ: '',
        StartPDQRTime: '',
        EndPDQRTime: '',
        Status: '',
        OrderNumber: '',
        SkipCount: 0,
        MaxResultCount: 10,
        ContainKBDCRQ: false,
      },
      isFeekbackShows: {
        isFeekbackShow0: false,
        isFeekbackShow1: false,
        isFeekbackShow2: false,
        isFeekbackShow3: false,
      },
      feedbackTypeData: [],
      list: [
        {
          bomImportRecord: {},
          cgbUser: {},

          name: '12',
        },
      ],
      rules: {
        feedbackContent: [
          { required: true, type: 'string', message: '请输入反馈进度', trigger: 'blur' },
        ],
        uploadList: [{ required: true, message: '请上传相关图片', type: 'array', trigger: 'blur' }],
      },
      feedbackId: '',
      feekbackForm: { feedbackContent: '', guid: '', uploadList: this.uploadList },
      columns: [],
      newGuid: this.getGuid(),
      deliveryStatusData: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false,
      rangeTimeSDRQ: [],
      rangeTimeYQDCRQ: [],
      rangeTimeSJDCRQ: [],
      rangeTimePDQR: [],
      isShowModal: false,
      feedbacklist: [],
      noFeedbackTips: '未到反馈时间',
      modalLoading: false,
      supplierName: '',
      statusList: [],
      productionLineList: [],
      feekbackStatusList: [],
      arrivalStatusList: [],
      orderTakingStatusList: [],
      isShowCancel: false,
      isShowCancelBtn: false,
      feedbackguid: '',
      cancelId: 0,
      currentId: '',
      seleceIdSet: [],
      defaultList: [
        {
          name: 'image-demo-1.jpg',
          url: 'https://file.iviewui.com/images/image-demo-1.jpg',
        },
        {
          name: 'image-demo-2.jpg',
          url: 'https://file.iviewui.com/images/image-demo-2.jpg',
        },
      ],
      imgName: '',
      visible: false,
      uploadList: [],
    }
  },
  mounted() {
    this.getInit()
    // this.getpage()
  },

  methods: {
    async getInit() {
      const result = await this.$Ajax('/api/services/app/GZBDataItem/GetMgrInitData')
      this.statusList = result.data.result.statusList
      this.productionLineList = result.data.result.productionLineList
      this.feekbackStatusList = result.data.result.feekbackStatusList
      this.orderTakingStatusList = result.data.result.orderTakingStatusList
      this.arrivalStatusList = result.data.result.arrivalStatusList
      this.isShowCancelBtn = result.data.result.isShowCancelBtn
      this.rangeTimeSDRQ = result.data.result.rangeTimeSDRQ
      this.deliveryStatusData = result.data.result.deliveryStatusData
      this.feedbackTypeData = result.data.result.feedbackTypeData
      this.getColumn()

      this.getpage(1)
      // console.log("result", result);
    },
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      this.seleceIdSet = []
      if (params === 1) {
        this.query.SkipCount = 0
        this.currentPage = 1
      }

      if (this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = moment(this.rangeTimeSDRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = moment(this.rangeTimeSDRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = ''
      }
      if (!this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = ''
      }

      if (this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = moment(this.rangeTimeYQDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = moment(this.rangeTimeYQDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = ''
      }
      if (!this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = ''
      }

      if (this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = moment(this.rangeTimeSJDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = moment(this.rangeTimeSJDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = ''
      }
      if (!this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = ''
      }

      if (this.rangeTimePDQR[0]) {
        this.query.StartPDQRTime = moment(this.rangeTimePDQR[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimePDQR[1]) {
        this.query.EndPDQRTime = moment(this.rangeTimePDQR[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimePDQR[0]) {
        this.query.StartPDQRTime = ''
      }
      if (!this.rangeTimePDQR[1]) {
        this.query.EndPDQRTime = ''
      }

      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/GZBDataItem/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
      // console.log(this.list);
    },

    closeModel() {
      this.isShowModal = false
      this.isFeekbackShow = false
    },
    getGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    //点击反馈记录
    feekbackHandel(imageFiles, index, id) {
      this.currentId = id
      this.removeFeekbackShows()
      this.getModalInit(this.feedbackguid)
      this.uploadList = []
      for (let index = 0; index < imageFiles.length; index++) {
        this.uploadList.push({ guid: imageFiles[index].fileGuids, imageUrl: imageFiles[index].url })
      }

      this.isFeekbackShows['isFeekbackShow' + index] = true
      this.feekbackForm = { feedbackContent: '', guid: '', uploadList: [] }
      let name = 'feekbackForm' + index
      // this.$refs[name][0].resetFields()
      // console.log("🚀 ~ file: ControlList.vue:355 ~ feekbackHandel ~ this.$refs[name][0]:", this.$refs[name][0])
    },
    closefeedback(index) {
      this.isFeekbackShows['isFeekbackShow' + index] = false
    },
    removeFeekbackShows() {
      this.isFeekbackShows.isFeekbackShow0 = false
      this.isFeekbackShows.isFeekbackShow1 = false
      this.isFeekbackShows.isFeekbackShow2 = false
      this.isFeekbackShows.isFeekbackShow3 = false
    },
    //提交
    async feekbackSub(index, guid) {
      // debugger
      let name = 'feekbackForm' + index
      this.feekbackForm.guid = guid
      this.feekbackForm.uploadList = this.uploadList

      // if(this.feekbackForm.uploadList.length>0&&this.feekbackForm.feedbackContent!=''){
      //  const data = await this.$Ajax.post(
      //   'api/services/app/GZBDataItem/SubmitFeedback',
      //   this.feekbackForm
      // )
      //   if (data.data.success) {
      //   this.$Message.success('反馈成功')
      //   this.getModalInit(this.feedbackId)
      //   this.getpage()
      // }
      // }else{

      // this.$refs[name][0].validate(async (valid) => {
      //   if (valid) {

      //   }
      // })
      // }
      this.$refs[name][0].validate(async (valid) => {
        if (valid) {
          const data = await this.$Ajax.post(
            'api/services/app/GZBDataItem/SubmitFeedback',
            this.feekbackForm
          )
          if (data.data.success) {
            this.$Message.success('反馈成功')
            this.getModalInit(this.feedbackguid)
            this.getpage()
          }
        }
      })
    },
    //批量选择
    tabSelectionChange(selection) {
      console.log('🚀 ~ file: ControlList.vue:447 ~ tabSelectionChange ~ selection:', selection)
      let _this = this
      this.seleceIdSet = []
      selection.map((data) => {
        _this.seleceIdSet.push(data.id)
      })
    },
    //批量接单
    async bulkOrder() {
      if (this.seleceIdSet.length > 0) {
        try {
          const result = await this.$Ajax.post(
            `api/services/app/GZBDataItem/BulkAcknowledgingBySupplier`,
            { gzbDataItemIds: this.seleceIdSet }
          )
          this.$Message.success('接单成功')
          this.getpage()
        } catch (error) {
          this.$Message.error('接单失败')
        }
      } else {
        this.$Message.warning('至少选择一个')
      }
    },
    handleRemove(file, fileList) {
      this.$Modal.confirm({
        title: '确定删除图片？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let res = await this.$Ajax.delete(
            'api/services/app/ComFile/DeleteFileByGuid?guid=' + file
          )
          if (res.data.success) {
            this.uploadList.splice(this.uploadList.indexOf(file), 1)
            // this.$Message.success('删除成功')
            this.$Notice.success({
              title: '删除成功',
            })
          } else {
            this.$Message.success('删除失败')
          }
          this.$emit('getTab', params.row.customerId)
        },
      })
    },
    handleSuccess(res, file) {
      console.log('🚀 ~ file: ControlList.vue:435 ~ handleSuccess ~ file:', file)
      console.log('🚀 ~ file: ControlList.vue:366 ~ handleSuccess ~ res:', res)
      this.$refs.upload[0].clearFiles()
      console.log(
        '🚀 ~ file: ControlList.vue:438 ~ handleSuccess ~ this.$refs.upload:',
        this.$refs.upload
      )
      this.uploadList.push(res.result)
      this.getGuid()
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '图片上传失败',
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '图片上传失败',
        desc: '图片不能超出4M',
      })
    },
    handleBeforeUpload(file) {
      this.newGuid = this.getGuid()
      const check = this.uploadList.length < 8
      if (!check) {
        this.$Notice.warning({
          title: '最多只能上传8张.',
        })
      } else {
      }
      return check
    },

    reset() {
      this.query = {
        IncludeBOMImportRecord: true,
        controlDisable: true,
        loadFeedbackStatus: true,
        IncludeSupplier: true,
        IncludeCGBUser: true,
        ProjectName: '',
        feedbackStatus: '',
        CGBUserName: '',
        StartSDRQ: '',
        EndSDRQ: '',
        StartYQDCRQ: '',
        EndYQDCRQ: '',
        StartSJDCRQ: '',
        EndSJDCRQ: '',
        Status: '',
        SupplierName: '',
        ProductionLineName: '',
        StartPDQRTime: '',
        EndPDQRTime: '',
        OrderNumber: '',
        ContainKBDCRQ: false,
      }
      this.rangeTimeSDRQ = []
      this.rangeTimeYQDCRQ = []
      this.rangeTimeSJDCRQ = []
      this.rangeTimePDQR = []
      this.getpage(1)
    },
    getColumn() {
      let columns = []
      console.log(
        '🚀 ~ file: ControlList.vue:547 ~ getColumn ~ this.isShowCancelBtn:',
        this.isShowCancelBtn
      )

      if (this.isShowCancelBtn) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center',
        })
      }
      columns.push(
        {
          title: '导入数据类型',
          render: (h, params) => {
            return h(
              'span',
              params.row.bomImportRecord.importDataTypeText
                ? params.row.bomImportRecord.importDataTypeText
                : ''
            )
          },
          width: 120,
        },
        {
          title: '项目名称',
          key: 'c项目名称',
          width: 180,
        },
        {
          title: '订单号',
          key: 'c订单号',
          width: 180,
        },
        {
          title: '全名',
          key: 'c全名',
          width: 200,
        },
        {
          title: '物料材质',
          key: 'c物料材质',
          width: 90,
        },
        {
          title: '原料长度',
          key: 'c原料长度',
          width: 90,
        },
        {
          title: '原料宽度',
          key: 'c原料宽度',
          width: 90,
        },
        {
          title: '原料高度',
          key: 'c原料高度',
          width: 90,
        },
        {
          title: '原料直径',
          key: 'c原料直径',
          width: 90,
        },
        {
          title: '图号',
          key: 'c图号',
          width: 140,
        },
        {
          title: '需求数量',
          key: 'c数量',
          width: 90,
        },
        {
          title: '单位',
          key: 'c单位',
          width: 80,
        },
        {
          title: '重量/面积',
          key: 'c重量or面积',
          width: 90,
        },
        {
          title: '单价',
          key: 'c单价',
          width: 80,
        },
        {
          title: '工件费',
          key: 'c工件费',
          width: 80,
        },
        {
          title: '金额',
          key: 'c金额',
          width: 80,
        },
        {
          title: '承接厂商',
          key: 'supplierName',
          width: 90,
        },
        {
          title: '所属',
          key: 'c所属',
          width: 80,
        },
        {
          title: '类别1',
          key: 'c类别1',
          width: 80,
        },
        {
          title: '类别2',
          key: 'c类别2',
          width: 80,
        },
        {
          title: '类别3',
          key: 'c类别3',
          width: 80,
        },
        {
          title: '产品类型',
          key: 'c模具类型',
          width: 90,
        },
        {
          title: '产线',
          key: 'c产线',
          width: 140,
        },

        {
          title: '受单日期',
          render: (h, params) => {
            return h(
              'span',
              params.row.c受单日期 ? this.$moment(params.row.c受单日期).format('YYYY-MM-DD') : ''
            )
          },
          width: 120,
        },
        {
          title: '派单确认时间',
          render: (h, params) => {
            return h('span', params.row.supplierAcknowledgingTimeText)
          },
          width: 140,
        },
        {
          title: '要求到厂日期',
          render: (h, params) => {
            return h(
              'span',
              params.row.c要求到厂日期
                ? this.$moment(params.row.c要求到厂日期).format('YYYY-MM-DD')
                : ''
            )
          },
          width: 120,
        },
        {
          title: '实际到厂日期',
          render: (h, params) => {
            return h(
              'span',
              params.row.c实际到厂日期
                ? this.$moment(params.row.c实际到厂日期).format('YYYY-MM-DD')
                : ''
            )
          },
          width: 120,
        },
        {
          title: '延误天数',
          key: '延误天数',
          width: 90,
        },
        {
          title: '反馈状态',
          key: 'feedbackStatus',
          width: 140,
        },
        {
          title: '交付状态',
          render: (h, params) => {
            return h(
              'div',
              {
                style: {
                  color:
                    params.row.deliveryStatus === '正常'
                      ? ''
                      : params.row.deliveryStatus === '临期'
                      ? '#ff9900'
                      : 'red',
                },
              },
              params.row.deliveryStatus
            )
          },
          key: 'deliveryStatus',
          width: 90,
        },
        {
          title: '落实结果',
          slot: 'implementResult',
          width: 180,
        },
        {
          title: '状态',
          key: 'statusText',
          width: 90,
        },
        {
          title: '采购负责人',
          render: (h, params) => {
            return h('span', params.row.cgbUser.name ? params.row.cgbUser.name : '')
          },
          width: 100,
        },
        {
          title: '反馈规则',
          minWidth: 150,
          key: 'feedbackTypeText',
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      console.log(params.row)
                      this.removeFeekbackShows()
                      this.getModalInit(params.row.guid)
                      this.feedbackId = params.row.id
                      this.feedbackguid = params.row.guid
                      this.isShowModal = true
                    },
                  },
                },
                '反馈记录'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    display:
                      params.row.statusText === '已取消' ||
                      params.row.statusText === '已结束' ||
                      this.isShowCancelBtn
                        ? 'none'
                        : '',
                  },
                  on: {
                    click: () => {
                      this.isShowCancel = true
                      this.cancelId = params.row.id
                    },
                  },
                },
                '取消'
              ),
            ])
          },
        }
      )
      this.columns = columns
      console.log('🚀 ~ file: ControlList.vue:814 ~ getColumn ~ this.columns:', this.columns)
    },
    async confirmCancel() {
      this.isShowCancel = false

      const data = await this.$Ajax.post(
        `/api/services/app/GZBDataItem/CancelGzbItemData?id=${this.cancelId}`,
        {}
      )
      if (data.success === false) {
        this.$Message.error(result.error.message)
        this.isShowModal = false
        return
      }
      this.$Message.success('取消成功')
      this.getpage()
      this.$store.dispatch({ type: 'purchase/setCancelData', data: true })
    },
    async getModalInit(id) {
      this.$Spin.show()
      this.modalLoading = true
      const result = await this.$Ajax(`/api/services/app/GZBDataItem/Get_PC?guid=${id}`)
      this.$Spin.hide()
      this.modalLoading = false
      if (result.success === false) {
        this.$Message.error(result.error.message)
        this.isShowModal = false
        return
      }
      this.supplierName = result.data.result.supplierName
      this.feedbacklist = result.data.result.gzbDataItem_SupplierFeedbackDtos
    },
    exportControlList() {
      if (!this.query.ProjectName.trim()) {
        this.query.ProjectName = ''
      }
      if (!this.query.OrderNumber.trim()) {
        this.query.OrderNumber = ''
      }
      if (!this.query.CGBUserName.trim()) {
        this.query.CGBUserName = ''
      }
      if (this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = moment(this.rangeTimeSDRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = moment(this.rangeTimeSDRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSDRQ[0] || !this.rangeTimeSDRQ[1]) {
        this.query.StartSDRQ = ''
        this.query.EndSDRQ = ''
      }

      if (this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = moment(this.rangeTimeYQDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = moment(this.rangeTimeYQDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeYQDCRQ[0] || !this.rangeTimeYQDCRQ[1]) {
        this.query.StartYQDCRQ = ''
        this.query.EndYQDCRQ = ''
      }

      if (this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = moment(this.rangeTimeSJDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = moment(this.rangeTimeSJDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSJDCRQ[0] || !this.rangeTimeSJDCRQ[1]) {
        this.query.StartSJDCRQ = ''
        this.query.EndSJDCRQ = ''
      }

      if (this.rangeTimePDQR[0]) {
        this.query.StartPDQRTime = moment(this.rangeTimePDQR[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimePDQR[1]) {
        this.query.EndPDQRTime = moment(this.rangeTimePDQR[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimePDQR[0] || !this.rangeTimePDQR[1]) {
        this.query.StartPDQRTime = ''
        this.query.EndPDQRTime = ''
      }
      const date = moment(new Date()).format('yyyyMMDDHHmm')
      let _this = this
      this.query.ProjectName
      let consturl =
        `${this.$constDefinition.baseUrl}/api/Export/ExportGZBItemData?ProductionLineName=${this.query.ProductionLineName}` +
        `&SupplierName=${this.query.SupplierName}` +
        `&ProjectName=${this.query.ProjectName}` +
        `&OrderNumber=${this.query.OrderNumber}` +
        `&CGBUserName=${this.query.CGBUserName}` +
        `&FeedbackStatus=${this.query.feedbackStatus}` +
        `&OrderTakingStatus=${this.query.orderTakingStatus}` +
        `&StartSDRQ=${this.query.StartSDRQ}` +
        `&EndSDRQ=${this.query.EndSDRQ}` +
        `&StartYQDCRQ=${this.query.StartYQDCRQ}` +
        `&EndYQDCRQ=${this.query.EndYQDCRQ}` +
        `&ArrivalStatus=${this.query.arrivalStatus}` +
        `&StartSJDCRQ=${this.query.StartSJDCRQ}` +
        `&EndSJDCRQ=${this.query.EndSJDCRQ}` +
        `&ContainKBDCRQ=${this.query.ContainKBDCRQ}` +
        `&Status=${this.query.Status}` +
        `&StartPDQRTime=${this.query.StartPDQRTime}` +
        `&EndPDQRTime=${this.query.EndPDQRTime}` //下载地址url
      consturl = consturl.replace(/\+/g, '%2B')
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        console.log(xhr)
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `管制表${date}.xlsx` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    exportControlStatusList() {
      if (!this.query.ProjectName.trim()) {
        this.query.ProjectName = ''
      }
      if (!this.query.OrderNumber.trim()) {
        this.query.OrderNumber = ''
      }
      if (!this.query.CGBUserName.trim()) {
        this.query.CGBUserName = ''
      }
      if (this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = moment(this.rangeTimeSDRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = moment(this.rangeTimeSDRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSDRQ[0] || !this.rangeTimeSDRQ[1]) {
        this.query.StartSDRQ = ''
        this.query.EndSDRQ = ''
      }

      if (this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = moment(this.rangeTimeYQDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = moment(this.rangeTimeYQDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeYQDCRQ[0] || !this.rangeTimeYQDCRQ[1]) {
        this.query.StartYQDCRQ = ''
        this.query.EndYQDCRQ = ''
      }

      if (this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = moment(this.rangeTimeSJDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = moment(this.rangeTimeSJDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeSJDCRQ[0] || !this.rangeTimeSJDCRQ[1]) {
        this.query.StartSJDCRQ = ''
        this.query.EndSJDCRQ = ''
      }

      if (this.rangeTimePDQR[0]) {
        this.query.StartPDQRTime = moment(this.rangeTimePDQR[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimePDQR[1]) {
        this.query.EndPDQRTime = moment(this.rangeTimePDQR[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimePDQR[0] || !this.rangeTimePDQR[1]) {
        this.query.StartPDQRTime = ''
        this.query.EndPDQRTime = ''
      }
      const date = moment(new Date()).format('yyyyMMDDHHmm')
      let _this = this
      this.query.ProjectName
      let consturl =
        `${this.$constDefinition.baseUrl}/api/Export/ExportGZBItemStatusStatistics?ProductionLineName=${this.query.ProductionLineName}&SupplierName=${this.query.SupplierName}&ProjectName=` +
        this.query.ProjectName +
        `&FeedbackStatus=${this.query.feedbackStatus}` +
        `&ArrivalStatus=${this.query.arrivalStatus}` +
        `&OrderTakingStatus=${this.query.orderTakingStatus}` +
        `&OrderNumber=${this.query.OrderNumber}&CGBUserName=${this.query.CGBUserName}&StartSDRQ=${this.query.StartSDRQ}&EndSDRQ=${this.query.EndSDRQ}&StartYQDCRQ=${this.query.StartYQDCRQ}&EndYQDCRQ=${this.query.EndYQDCRQ}&StartSJDCRQ=${this.query.StartSJDCRQ}&EndSJDCRQ=${this.query.EndSJDCRQ}&ContainKBDCRQ=${this.query.ContainKBDCRQ}&Status=${this.query.Status}&StartPDQRTime=${this.query.StartPDQRTime}&EndPDQRTime=${this.query.EndPDQRTime}` //下载地址url
      consturl = consturl.replace(/\+/g, '%2B')
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        console.log(xhr)
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `管制表状态统计${date}.xlsx` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    previewImg(url) {
      console.log(url)
      url = url.replace('previewThumbnail', 'preview')
      window.open(this.$constDefinition.baseUrl + url)
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
    async handleImplementResultBlur(row) {
      // 检查是否有输入内容
      // if (!row.implementResultInput || !row.implementResultInput.trim()) {
      //   return
      // }

      try {
        // 调用API保存落实结果
        const result = await this.$Ajax.post('/api/services/app/GZBDataItem/SaveImplementResult', {
          guid: row.guid,
          implementResult: row.implementResult,
        })

        if (result.data.success) {
          this.$Message.success('落实结果保存成功')
          // 可选：刷新列表数据
          // this.getpage()
        }
      } catch (error) {
        this.$Message.error('保存失败: ' + (error.message || '未知错误'))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.feedback {
  margin-top: 10px;
}
.feekbackbg {
  background: #eee;
  padding: 10px 0px 0px 10px;
  border-radius: 5px;
  /deep/.ivu-form-item {
    margin-bottom: 20px;
  }
  .img {
    // margin: 0;
    /deep/.ivu-form-item-content {
      min-height: 60px;
    }
  }

  /deep/.ivu-upload-list-file {
    width: 320px;
  }
}
.ivu-btn {
  margin-right: 5px;
}
.img {
  width: 80px;
  // height: 80px;
  margin-right: 5px;
}
.modal-cont /deep/ .ivu-modal-header-inner {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 200px;
}
.modal-cont-jilu /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: left;
}
.footer {
  text-align: center;
}

.cont {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.imgbox {
  display: inline-block;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
